import { PLANTILLA_DE_LA_GENTE } from "./constants";
import { firebaseDatabase } from "./firebase";
import axios from "axios";
import { PDFDocument, rgb } from 'pdf-lib';


export const getCatalog = async (id) => {
    const catalogRespose = firebaseDatabase.collection(`catalogos/${id}/data`);
    return catalogRespose;
};

export const onlyUnique = (label, index, self) => {
    return self.indexOf(label) === index;
}

export const returnDataCatalog = (catalog, payload, param, campo) => {
    let res = "";
    if (catalog.length > 0 && payload && param && campo) {
        if (payload === "0")
            res = "Fuera del valle"
        else {
            res = catalog.find(o => o[param].toUpperCase() === payload.toUpperCase());
            if (res)
                res = res[campo];
        }
    }
    return res;
}

export const returnDataCatalogV2 = async (catalog, payload, param, campo) => {
    let res = " ";

    if (catalog.length > 0) {
        res = catalog.find(o => o[param] === payload);
        if (res)
            res = res[campo];

    }
    return res;
}

export const generatePDFbUtil = async (base64String) => {
    try {
        // Decodificar la cadena Base64
        const uint8Array = atob(base64String).split('').map(char => char.charCodeAt(0));
        const pdfBytes = new Uint8Array(uint8Array);

        // Crear un Blob a partir de los bytes del PDF
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });

        // Crear una URL para el Blob
        const url = URL.createObjectURL(blob);

        // Crear un elemento <a> para simular un clic en el enlace de descarga
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Relacion de trabajadores.pdf';

        // Simular un clic en el enlace de descarga
        document.body.appendChild(link);
        link.click();

        // Limpiar después de la descarga
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error al generar el PDF:', error);
    }
};

export const returnDataCatalogV3 = async (catalog, payload, param, campo) => {

    let res = payload;

    if (catalog.length > 0 && payload) {
        res = catalog.find(o => (o[param]).toUpperCase().includes(payload.toUpperCase()));
        if (res)
            res = res[campo];

    }
    return res;
}

export const dataRnecToAfiliacion = (id, data, type, key) => {
    let resul = null;
    if (type === "representante") {
        const value = data[key];
        if (value && value.length > 0)
            resul = value;
    }
    if (type === "contacto" && data.length > 0) {

        data.forEach(e => {
            if (e.nuip === id) {
                resul = e[`${key}`];
            }
        });
    }
    if (key === "fechaExpedicion")
        if (resul !== null) {
            const aux = resul.split("/")
            resul = `${aux[2]}-${aux[1]}-${aux[0]}`;

        }
    return resul;
}

export const returnDataCatalogV4 = async (catalog, payload, param, campo) => {
    let res = " ";

    if (catalog.length > 0) {
        res = catalog.find(o => o[param] === payload);
        if (res)
            res = res[campo];

    }
    return res;
}

export const onlyUniqueLabel = (catalog) => {
    return catalog.filter(e => e.id_ticl === "4");
}

export const exist = (array, value) => {
    var ban = false;
    array.forEach(element => {
        if (element.value === value) {
            ban = true;
            return;
        }
    });
    return ban;
}

export const existLabel = (array, label) => {
    var ban = false;
    if (array.length > 0) {
        array.forEach(element => {
            if (element.label === label) {
                ban = true;
                return;
            }
        });
    }
    return ban;
}

export const retornaIdCatalog = (catalog, label) => {
    var ban = "";
    if (catalog && catalog.length > 0) {
        const res = catalog.find(e => e.label === label);
        if (res)
            ban = res.value;
    }
    return ban;
}

export const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export const getAsyncCatalog = async (type) => {
    try {
        let catalogo = [];
        const catalogRespose = await firebaseDatabase.collection(`catalogos/${type}/data`);
        const collection = await catalogRespose.get();

        await collection.docs.map(doc => {
            catalogo.push(doc.data());
        });
        return catalogo;
    } catch (error) {
        throw ` utils.js - getAsyncCatalog - ${error}`;
    }

}

export const manejoDeexepciones = (err) => {
    console.log(err);
    let error = "Error: El servidor no está disponible en este momento."
    switch (true) {
        case (`${err} `).includes("Network Error"):
            error = "Error: No se pudo conectar al servidor. Verifique su conexión a Internet e intente nuevamente."
            break;
        case (`${err} `).includes("Not Found"):
            error = "Error: La página que está buscando no existe."
            break;
        case (`${err} `).includes("Internal Server Error"):
            error = "Error: Se produjo un error interno en el servidor."
            break;
        case (`${err} `).includes("Service Unavailable"):
            error = "Error: El servidor está temporalmente inactivo."
            break;
        case (`${err} `).includes("status code 500"):
            error = "Error: El servidor presenta un error interno. Está temporalmente inactivo."
            break;
        default:
            break;
    }
    return error;
}

export const getAsyncCatalogV2 = async (type) => {
    try {
        return new Promise(async (resolve, reject) => {

            let catalogo = [];
            await firebaseDatabase.collection(`catalogos/${type}/data`)
                .get().then((QuerySnapshot) => {
                    QuerySnapshot.docs.map(doc => {
                        catalogo.push(doc.data());
                    });
                    resolve(catalogo);
                }).catch((error) => {
                    console.error(error);
                    reject(error);
                });

        });
    } catch (error) {
        console.error("exception:", error);
        throw `utils.js - getAsyncCatalogV2 - ${error}`;
    }
}

export const getAsyncConfiguration = async (type) => {
    let configuration = false;
    const configurationRespose = await firebaseDatabase.collection(`configuration`).doc(type).get()
        .then(
            (snapshot) => {
                if (snapshot.exists) {
                    configuration = snapshot.data().value;
                };
            });
    return configuration;
}


export const getAsyncUserRolFirebase = async (email) => {
    try {
        return new Promise(async (resolve, reject) => {
            await firebaseDatabase.collection(`catalogos/USERS_ROLS_SUCURSALES/data`)
                .where("email", "==", email).get().then((QuerySnapshot) => {
                    QuerySnapshot.docs.map((doc, i) => {
                        if (doc.exists) resolve(doc.data());
                    })
                }).catch((error) => {
                    console.error(error);
                    reject(error);
                });

        });
    } catch (error) {
        console.error("exception:", error);
        throw `utils.js - getAsyncUserRolFirebase - ${error}`;
    }
}


export const getAsyncCollection = async (type) => {
    var collection = false;
    const catalogRespose = await firebaseDatabase.collection(`catalogos`).doc(`${type}`).get();
    collection = catalogRespose.data();
    return collection;
}

export const emptyObject = (value) => {
    return typeof value !== 'object' && value !== undefined && value !== null && value !== "null" ? value : '';
}

export const emptyJson = (value) => {
    return value === undefined || JSON.stringify(value) === '{}' ? true : false;
}

export const emptyObjectEmp = (value, replace) => {
    return typeof value !== 'object' && value !== undefined ? value : replace;
}

export const emptyCero = (value) => {
    return value !== '' && value !== undefined && value !== null ? value : '0'
}

export const primeraMayuscula = (cadena) => {
    return cadena[0].toUpperCase() + cadena.substring(1);
}

export const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export const removeAccents = (str) => {
    const acentos = { 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U', '´': ' ', };
    return (str.replace(/[^a-zA-Z0-9\s]/g, '')).split('').map(letra => acentos[letra] || letra).join('').toString();
}


export const cortarMSM = (mens, limite) => {
    try {
        let newMsm = mens;
        if (mens && mens.length > limite) {
            newMsm = mens.substr(0, limite - 1)
        }
        return newMsm;
    } catch (error) {
        throw `cortarMSM - ${error}`

    }
}

export const letras_numbers = (str) => {
    //verifica si una caden esta compuesta solo por letras numeros y espacios
    var patt = new RegExp(/^[A-Za-z0-9\s]+$/g);
    return patt.test(str);
}

export const getFechaOfDate = (date) => {


    let fecha = ""

    if (date && date.seconds) {
        fecha = date.toDate();
    } else {
        fecha = new Date(date);
    }
    let dia = fecha.getDate();
    let mon = fecha.getMonth() + 1;
    if (fecha.getDate() < 10) {
        dia = `0${fecha.getDate()}`;
    }
    if (mon < 10) {
        mon = `0${mon}`;
    }

    return `${fecha.getFullYear()}-${mon}-${dia}`
}


export const converArrayToStringLatin1 = (json) => {
    return JSON.parse(json.data.toString("latin1"));
}

export const getFechaOfDateRya = (date) => {
    let fecha = ""

    if (date && date.seconds) {
        fecha = date.toDate();
    } else {
        fecha = new Date(date);
    }
    let dia = fecha.getDate();
    let mon = fecha.getMonth() + 1;
    if (fecha.getDate() < 10) {
        dia = `0${fecha.getDate()}`;
    }
    if (fecha.getMonth() + 1 < 10) {
        mon = `0${mon}`;
    }

    return `${fecha.getFullYear()}-${mon}-${dia}`
}

export const getFechaIn_dd_mm_yy = (date) => {
    let fecha = new Date();
    fecha = (fecha.toUTCString()).split(" ")
    return `${fecha[1]}-${fecha[2]}-${fecha[3]}`
}


export const filterDataRnec = (admin, contact, arrRnec) => {
    let temp = [];
    let ban = false;
    admin && admin.length > 0 && admin.forEach(e => {
        if (e.numberIdStaff === contact.nuip && e.typeIdStaff === "CC")
            ban = true;
    });

    if (ban) {
        arrRnec.forEach(e => {
            if (contact.nuip === e.nuip) {
                temp.push(contact)
            } else {
                temp.push(e)
            }
        });
    } else {
        arrRnec.push(contact);
        temp = [...arrRnec];
    }
    return temp;
}

export const encode = (data) => {
    return Buffer.from(data, 'utf-8').toString('base64')
}

export const decode = (data) => {
    return Buffer.from(data, 'base64').toString('utf-8')
}

export const getFechaOfDateYearMonth = (date) => {
    let fecha = ""
    if (date && date.seconds) {
        fecha = date.toDate();
    } else {
        fecha = new Date(date);
    }
    let dia = fecha.getDate();
    let mon = fecha.getMonth() + 1;
    if (fecha.getDate() < 10) {
        dia = `0${fecha.getDate()}`;
    }
    if (fecha.getMonth() + 1 < 10) {
        mon = `0${mon}`;
    }

    return `${fecha.getFullYear()}-${mon}`
}

export const getFechaOfDateV2 = (date) => {

    let fecha = ""
    if (date && date.seconds) {
        fecha = date.toDate();
    } else {
        fecha = new Date(date);
    }
    let dia = fecha.getDate();
    let mon = fecha.getMonth() + 1;
    if (fecha.getDate() < 10) {
        dia = `0${fecha.getDate()}`;
    }
    if (fecha.getMonth() < 10) {
        mon = `0${mon}`;
    }

    return `${fecha.getFullYear()}-${mon}-${dia}`
}

export const getFechaOfDateV4 = (date) => {

    let fecha = "";
    let res = "";
    if (date) {
        if (date.seconds) {
            fecha = date.toDate();
        } else {
            const diferenciaHorariaMinutos = 300;
            fecha = new Date(date);
            fecha.setMinutes(fecha.getMinutes() + diferenciaHorariaMinutos);
        }

        const mm = (fecha.getMonth() + 1)
        const dd = (fecha.getDate());
        const hh = (fecha.getHours());
        const mmh = (fecha.getMinutes());
        const ssh = (fecha.getSeconds());
        res = `${dd > 9 ? "" + dd : "0" + dd}-${mm > 9 ? "" + mm : "0" + mm}-${fecha.getFullYear()}    ${hh > 9 ? "" + hh : "0" + hh}:${mmh > 9 ? "" + mmh : "0" + mmh}:${ssh > 9 ? "" + ssh : "0" + ssh}`;

    }
    return res;
}

export const getFechaOfDateV3 = () => {

    let fecha = new Date();

    let dia = fecha.getDate();
    let mon = fecha.getMonth() + 1;
    if (fecha.getDate() < 10) {
        dia = `0${fecha.getDate()}`;
    }
    if (fecha.getMonth() < 10) {
        mon = `0${mon}`;
    }

    const hh = (fecha.getHours());
    const mmh = (fecha.getMinutes());

    let year = `${fecha.getFullYear()}`;

    return `${dia} ${mon} ${year.slice(2, 4)}  ${hh}${mmh}`
}

export const getCodeOfDateSystem = () => {

    let fecha = new Date();

    let dia = fecha.getDate();
    let mon = fecha.getMonth() + 1;
    if (fecha.getDate() < 10) {
        dia = `0${fecha.getDate()}`;
    }
    if (fecha.getMonth() < 10) {
        mon = `0${mon}`;
    }

    const hh = (fecha.getHours());
    const mmh = (fecha.getMinutes());
    const ssh = (fecha.getSeconds());

    let year = `${fecha.getFullYear()}`;

    return `${year.slice(2, 4)}${mon}${dia}${hh}${mmh}${ssh}`
}

export const getFechaOfDateMonth = (date) => {
    const fecha = new Date(date);
    let dia = fecha.getDate();
    let mon = fecha.getMonth() + 1;
    if (fecha.getDate() < 10) {
        dia = `0${fecha.getDate()}`;
    }
    if (mon < 10) {
        mon = `0${mon}`;
    }

    return `${mon}-${fecha.getFullYear()}`
}

export const saveHistoryEmpresas = async (action) => {
    const { idFormulario, history } = action
    try {
        await firebaseDatabase.collection(process.env.REACT_APP_FIREBASE_COLECCION_COMPANY)
            .doc(idFormulario)
            .collection("history")
            .add(history);
    } catch (error) {
        console.error(error);
    }
}

export const saveBdWebService = async (idFormulario, nameWs, body, responseStatus, response) => {
    try {

        if (nameWs === "HCPRegistrarAfiliacionEmpresa") {
            //  quitar anexos para guardar request

            let tempAnexos = []
            body.requestMessageOut.body.request.registrarAfilicionEmpresaRequest.formularioEmpresa.anexos.forEach(e => {
                e.anexo.base64Archivo = "";
                tempAnexos.push(e);
            });
            body.requestMessageOut.body.request.registrarAfilicionEmpresaRequest.formularioEmpresa.anexos = tempAnexos;
        }

        if (nameWs === "CRMCreaTicketContactenos") {
            //  quitar anexos para guardar request
            body.requestMessageIn.body.request.documentos[0].base64Archivo = "";
        }

        if (nameWs === "CRMCreaActualizaOportunidad") {
            //  quitar anexos para guardar request
            body.requestMessageOut.body.request.oportunidad.infoOportunidad.archivo[0].contenidoArchivo = "";
        }

        const msge = {
            fechaInvocacion: new Date(),
            idFormulario,
            nameWs,
            invocaFrom: "frontEnd",
            method: 'POST',
            responseStatus,
            webService: {
                body: JSON.stringify(body),
                response: JSON.stringify(response),
            }
        }
        await firebaseDatabase.collection(`${process.env.REACT_APP_FIREBASE_COLECCION_COMPANY}/${idFormulario}/webservices`)
            .add(msge);

    } catch (error) {
        throw `utils.js - saveBdWebService - ${error}`
    }
}

export const cleanRazonSocial = async (razon) => {
    let response = "";

    if (razon.length > 0) {
        const temp = await removeAccents(razon).split("");

        if (temp.length > 0) {
            let newCadena = ""
            let oldCadena = ""
            for (let e of temp) {
                newCadena = oldCadena + e;
                oldCadena = validRazonSocial(oldCadena, newCadena)
            }

            response = oldCadena;
        }

    }
    console.log(response);
    return response;
}
const validRazonSocial = (oldCadena, newValue) => {

    let response = oldCadena;

    let ban = false;
    if (newValue.length > 0) {

        if (newValue.match(/^(?!.*  )[^\s].*$/) && newValue.match(/^(?!.*\s[a-zA-Z0-9ñÑ]\s[a-zA-Z0-9ñÑ]\s).*$/)) {

            if (!newValue.match(/([a-zA-Z])\1{2,}/) && newValue.match(/^(?!.*([a-zA-Z])\1{2,}).*$/)) {
                ban = true;
            }

        }
        if (ban) {
            response = newValue; // only set when successful
        }

    }
    return response;

};

export const convNumFormat = (value) => {

    let res = ""
    if (value) {
        var aux = value.split("");
        const fin = aux.filter(e => e !== "," && e !== "." && e !== "$" && e !== " ");
        fin.forEach(i => {
            res += i;
        });
    }
    return parseInt(res);
}

export const ordenar = (a, b) => {
    if (a.label > b.label) {
        return 1;
    }
    if (a.label < b.label) {
        return -1;
    }
    return 0;
}

export const fontSizeCortar = (cadena) => {
    return cadena.length > 21 ? cadena.slice(0, 21) : cadena;
};

export const convertStringToDate = (str) => {
    const aux = str.split(" ");
    const t1 = aux[0].split("/");
    const t2 = aux[1].split(":");
    return new Date(parseInt(t1[2]), parseInt(t1[1]) - 1, parseInt(t1[0]), parseInt(t2[0]), parseInt(t2[1]), parseInt(t2[2]));

}

export const enviarEmailFormatDocument = (action) => {
    try {
        const { type, oportunidad, motivo, observacion, from, to, subject, numRegistro } = action


        switch (type) {
            case "DEVOLUCION":
                const devolucion = `<p>Apreciado usuario,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <p>Para nosotros es un placer saludarle en nombre de la Caja de Compensaci&oacute;n Familiar del Valle del Cauca, Comfenalco Valle Delagente.</p>
                <p>Le informamos que hemos realizado el proceso de verificaci&oacute;n para la afiliaci&oacute;n de su empresa, sin embargo, hemos evidenciado inconsistencias en los documentos recibidos, por lo tanto se realiza devoluci&oacute;n de la afiliaci&oacute;n por el siguiente motivo:</p>
                <p>${primeraMayuscula(motivo)}, ${observacion.toLowerCase()}</p>
                <p>Le invitamos a retomar la postulaci&oacute;n enviado la documentaci&oacute;n corregida por medio de nuestra <a href="https://afiliacionempresasprueba-f1bbf.web.app/empresas">Sucursal Virtual</a> con el mismo n&uacute;mero de registro: ${numRegistro} que ademas, se envi&oacute; al correo electr&oacute;nico registrado al iniciar su proceso de afiliaci&oacute;n. Recuerde que una vez enviados los documentos, la afiliaci&oacute;n pasa nuevamente a estar en proceso de validaci&oacute;n por parte del &aacute;rea correspondiente la cual le notificar&aacute; al correo electr&oacute;nico si la afiliaci&oacute;n es aprobada o no.</p>
                <p>Se aclara que hasta tanto no se reciba la documentaci&oacute;n faltante, Comfenalco Valle Delagente no podr&aacute; proceder a realizar la afiliaci&oacute;n de su empresa.</p>
                <p>Estamos siempre a su disposici&oacute;n para responder sus requerimientos a trav&eacute;s de nuestros canales de atenci&oacute;n. <a href="https://www.comfenalcovalle.com.co/personas/servicio-al-cliente/">Con&oacute;celos aqu&iacute;</a>.</p>
                <p>Gracias por confiar en nuestra Caja de Compensaci&oacute;n Familiar.</p>
                <p>&nbsp;</p>
                <p>Cordialmente,</p>`;
                enviarEmailGenerico({ from, to, subject, message: devolucion });
                break;
            case "ANULACION":
                const anulacion = `<p>Apreciado usuario,</p>
                <p>Para nosotros es un placer saludarle en nombre de la Caja de Compensaci&oacute;n Familiar del Valle del Cauca, Comfenalco Valle Delagente.</p>
                <p>Le informamos que hemos realizado el proceso de verificaci&oacute;n para la afiliaci&oacute;n de su empresa, sin embargo, hemos evidenciado inconsistencias en los documentos recibidos, por lo tanto se realizar la anulaci&oacute;n de la afiliaci&oacute;n por el siguiente motivo:</p>
                <p>${primeraMayuscula(motivo)}, ${observacion.toLowerCase()}</p>
                <p>Estamos siempre a su disposici&oacute;n para responder sus requerimientos a trav&eacute;s de nuestros canales de atenci&oacute;n. <a href="https://www.comfenalcovalle.com.co/personas/servicio-al-cliente/">Con&oacute;celos aqu&iacute;</a>.</p>
                <p>Gracias por confiar en nuestra Caja de Compensaci&oacute;n Familiar.</p>
                <p>Cordialmente,</p>`;
                enviarEmailGenerico({ from, to, subject, message: anulacion });
                break;
            case "OPORTUNIDAD":
                const oportunidadMen = `<p>Apreciado usuario,</p>
                <p>Para nosotros es un placer saludarle en nombre de la Caja de Compensaci&oacute;n Familiar del Valle del Cauca, Comfenalco Valle Delagente.</p>
                <p>Le informamos que el proceso de afiliaci&oacute;n de su empresa a la Caja de Compensaci&oacute;n Familiar fue registrado bajo el n&uacute;mero ${oportunidad}. En caso de presentar alguna novedad le ser&aacute; notificada por este medio en el cual se le indicar&aacute; informaci&oacute;n detallada y as&iacute;, podr&aacute; retomar la afiliaci&oacute;n a trav&eacute;s de nuestra <a href="https://afiliacionempresasprueba-f1bbf.web.app/empresas">Sucursal Virtual</a> con el mismo n&uacute;mero indicado.</p>
                <p>Estamos siempre a su disposici&oacute;n para responder sus requerimientos a trav&eacute;s de nuestros canales de atenci&oacute;n. <a href="https://www.comfenalcovalle.com.co/personas/servicio-al-cliente/">Con&oacute;celos aqu&iacute;</a>.</p>
                <p>Gracias por confiar en nuestra Caja de Compensaci&oacute;n Familiar.</p>
                <p>Cordialmente,</p>`;
                enviarEmailGenerico({ from, to, subject, message: oportunidadMen });
                break;

            default:
                break;
        }


    } catch (error) {
        console.error("Function.enviarEmailGenerico", error);
    }
}

export const enviarEmailGenerico = (action) => {
    try {
        const { from, to, subject, message } = action
        const url = process.env.REACT_APP_URL_SEND_EMAIL;


        const headers = {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
            'Access-Control-Allow-Credentials': 'true',
            "Access-Control-Allow-Headers": "x-requested-with, content-type",
            "Access-Control-Request-Headers": "access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,auth,authorization,cache-control,content-type,mode",
            'accept': "application/json, text/plain, */*",
            "Authorization": 'Basic Rk9STVVMQVJJT1NXRUI6WWsyMTkwX3c=',
            "content-type": "application/json",
            "Cache-Control": "no-cache",
            'mode': "opaque ",
        };
        let body = {
            from,
            to,
            subject,
            message: message + PLANTILLA_DE_LA_GENTE,
            attachments: [],
        }

        axios.create({
            headers,
        }).post(url, JSON.stringify(body))
            .then(response => {
                console.log(response.data)
            })
            .catch(err => {
                console.error('error invocando enviar email:' + err + " " + err.message)
                throw err;
            }
            )


    } catch (error) {
        console.error("Function.enviarEmailGenerico", error);
    }
}


export const notificaFalloWBS = (action) => {
    try {
        const { body, webService, response } = action

        const from = "Notificaciones bandeja comercial";
        const to = `<jairo.delgado@avanti-it.co>,<cjimenez@comfenalcovalle.com.co>`;
        const subject = "Notificación de fallo web service afiliación empresas";
        const message = `<div><p>El web service <b>${webService}</b> presento una respuesta inesperada, a lo cual se requiere tomar control de la acción esperada</p><p>Cuerpo del webservice</p><p>${JSON.stringify(body)}</p><p>Respuesta del webservice</p><p>${JSON.stringify(response)}</p> </div>`
        const res = enviarEmailGenerico({ from, to, subject, message })

    } catch (error) {
        throw `saga.js - notificaFalloWBS ${error}`;
    }
}


export const createNotaOportunidad = (action) => {
    const { items } = action;
    const type = items.stepPrincipal.afiliacionEmpresas.empleadorTypeCompany;
    let nota = "Datos de contacto:\n\n"
    if (type === "3") {
        const inicio = items.step0.datosinicio;
        nota = `${inicio.typeIdCompanyStart}  ${inicio.checkNumberStart}  ${inicio.employerNameStart.toUpperCase()} ${inicio.emailCompanyStart} ${inicio.smartPhoneRegistro} Representante legal directores y gerentes generales\n`;
    } else {
        items.step1.datospersonaladmin.forEach(e => {
            let nameCompleted = `${e.firstNameStaff} ${emptyObject(e.secondNameStaff)} ${e.firstLastnameStaff} ${emptyObject(e.secondLastnameStaff)}`;
            nota = `${nota} ${e.typeIdStaff} ${e.numberIdStaff} ${nameCompleted.toUpperCase()} ${e.emailStaff} ${e.smartPhoneBossStaff} ${emptyObject(e.jobBossStaff)}\n`
        });
    }
    return nota;
}

export const notificaDevAnulaBandejaComercial = (action) => {
    try {
        const { motivo, email, accion, observaciones } = action

        const from = "Notificaciones bandeja comercial";
        const to = `<${email}>`;
        const subject = `Notificación de ${accion} de parte de validación comercial`;
        const message = `<div><p>Despues de el proceso de validación por parte de nuestros asesores, se ha tomado la desición de: <b>${accion}</b> su postulación, el motivo de esta desición se base en que: ${motivo}, adicionalmente se agrega: ${observaciones}. </br>A lo cual se requiere comunicarse con el area encargada</p> </br> <p>Comfenalco valle delagente</p> </div>`
        const res = enviarEmailGenerico({ from, to, subject, message })

    } catch (error) {
        throw `saga.js - notificaFalloWBS ${error}`;
    }
}

export const conversion = (value) => {
    return (((value.replaceAll(".", "")).replaceAll("$", "")).replaceAll(" ", "")).replaceAll(",", "");
}

export const validPhoneRues = (value, type) => {
    return value.length === 10 && value.includes(type, 0) ? value : "";
}

export const createState = (state, catalog) => {
    console.log(`Creating state`, state, catalog);
    let res = []
    if (!state.find(e => e === "TODOS")) {
        let aux = []
        catalog.forEach(e => {
            state.forEach(c => {
                if (e.label === c) {
                    aux.push(e.value)
                }
            })
        });
        res = aux;
    }
    return res;
}
export const generaMacrosector = async (catalog, activity) => {

    let res = {}
    const actividad = catalog.find(e => e.label === activity);
    if (actividad) {
        const subSector = catalog.find(e => e.value === actividad.id_clec_padre);
        if (subSector) {
            const sector = catalog.find(e => e.value === subSector.id_clec_padre);
            if (sector) {
                const macro = catalog.find(e => e.value === sector.id_clec_padre);
                res = {
                    "macroSector": emptyObject(macro.codigoley),
                    "sector": emptyObject(sector.codigoley),
                    "subSector": emptyObject(subSector.codigoley),
                    "actividadEconomica": emptyObject(actividad.codigoley),
                }
            }
        }
    }

    return res;
}


export const validarCambios = async (before, after) => {
    try {
        let change = false;
        const newBefore = {
            step0: before.step0,
            step1: before.step1,
            step2: before.step2,
            step3: before.step3,
            step4: before.step4
        }
        const newAfter = {
            step0: after.step0,
            step1: after.step1,
            step2: after.step2,
            step3: after.step3,
            step4: after.step4
        }
        if (JSON.stringify(newBefore) === JSON.stringify(newAfter)) {
            console.log("no cambio")
        } else {
            console.log("Cambio")
            change = true;
        }
        return change;
    } catch (error) {
        throw `util.js - validarCambios - ${error}`
    }
}


export const consultaMsgParametrizado = async (catalog, clave) => {
    try {
        const msgSession = catalog.find(e => e.value === clave);
        if (!(msgSession && msgSession.download)) {
            return new Promise(async (resolve, reject) => {
                await firebaseDatabase.collection(`catalogos/MSG_PARAMETRIZADOS/data`).where('value', '==', clave)
                    .get().then((QuerySnapshot) => {
                        QuerySnapshot.docs.map(doc => {
                            if (doc.exists)
                                resolve({ text: doc.data().label, download: true, id: clave });
                            else
                                resolve({ text: msgSession.label, download: false, id: clave })
                        });
                    }).catch((err) => reject({ text: msgSession.label, download: false, id: clave }));
            });


        }
        else
            return { text: msgSession.label, download: msgSession.download, id: clave };
    } catch (error) {
        console.error(error);
        throw error;
    }
};

